'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocaleSwitcherContainer = exports.mapDispatchToProps = undefined;

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

var _decorator = require('helpers/decorator');

var _Sagas = require('decorators/Sagas');

var _modals = require('redux/modules/modals');

var _LocaleSwitcher = require('./LocaleSwitcher');

var _LocaleSwitcher2 = require('./LocaleSwitcher.saga');

var mapDispatchToProps = exports.mapDispatchToProps = {
  hideModal: _modals.hideModal,
  showModal: _modals.showModal,
  updateAccountLocale: _LocaleSwitcher2.updateAccountLocale
};

var LocaleSwitcherContainer = exports.LocaleSwitcherContainer = (0, _decorator.decorateWith)((0, _Sagas.withSagas)({
  watch: _LocaleSwitcher2.watchAccountLocaleSagas
}), (0, _reactRedux.connect)(null, mapDispatchToProps), _reactIntl.injectIntl)(_LocaleSwitcher.LocaleSwitcher);